import { WithExpandCell } from "app/pages/sales-intelligence/common-components/table-cells";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import { CrmRecordsCountCell } from "app/pages/sales-intelligence/modules/crm-integration/components/cells/CrmRecordsCountCell";
import type { LeadsSearchRow, TableRecord } from "app/pages/sales-intelligence/modules/leads-search";
import { useExpandableRow } from "app/pages/sales-intelligence/modules/leads-search/hooks/cells/useExpandableRow";
import type { ExpandedRowVariant } from "app/pages/sales-intelligence/modules/leads-search/types/expanded-row";
import { getLeadDomainFromRow } from "app/pages/sales-intelligence/modules/leads-search/utils/rows";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

// Temporary gate on the provider, until all providers are supported
const DEFAULT_SUPPORTED_PROVIDER: CrmIntegrationProvider = "salesforce";

type Props = {
    record: TableRecord<LeadsSearchRow>;
    value: number;
    integrationProvider: CrmIntegrationProvider;
};

const CrmRecordCountWithExpandCell = ({ record, value, integrationProvider }: Props) => {
    const variant: ExpandedRowVariant = { kind: "crm-records", integrationProvider };
    const { isExpanded, onToggle } = useExpandableRow(record.key, variant);

    return (
        <WithExpandCell
            onClick={onToggle}
            isExpanded={isExpanded}
        >
            <CrmRecordsCountCell
                value={value}
                iconName={integrationProvider}
            />
        </WithExpandCell>
    );
};

export const CrmRecordCountCellContainer = ({ record, value, integrationProvider }: Props) => {
    const domain = getLeadDomainFromRow(record);
    const isCellExpandable = [
        value >= 1,
        integrationProvider === DEFAULT_SUPPORTED_PROVIDER,
        is.nonEmptyString(domain),
    ].every(Boolean);

    return isCellExpandable ? (
        <CrmRecordCountWithExpandCell
            value={value}
            record={record}
            integrationProvider={integrationProvider}
        />
    ) : (
        <CrmRecordsCountCell
            value={value}
            iconName={integrationProvider}
        />
    );
};
